import { makeRequest } from '../../../lib/api';
import { objectToUrlParams } from 'modules/core/utils/url';
import {
  ClientStatisticReportRequest,
  TireServiceReportRequest,
  TireStorageReportRequest,
  WorkingHoursReportRequest,
} from './reportApi';

const A3_PATH = '/v1/a3service';
const CLIENT_PATH = '/v1/clients';
const REPORT_PATH = '/v1/reports';
const REPORT_ORDER_PATH = '/v1/reports/orders';

class reportController {
  getA3PaidFine = (data = {}) => {
    return makeRequest('post', `${ A3_PATH }/payments/find`, data);
  };

  getA3Availability = (data) => {
    return makeRequest('get', `${ A3_PATH }/penalties/availability?startDate=${ data?.startDate }&endDate=${ data?.endDate }`);
  };

  getClientRegistration = (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/clients/registration`, data);
  };

  getSettlementWithPartnerReport = (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/invoices`, data);
  };

  getOrdersWithInvoicesReport = (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/orders/with_invoices`, data);
  };

  getMobileStatisticsReport = (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/clients/mobile/statistics`, data);
  };

  getMobileStatisticsExtendedReport = (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/clients/mobile/statistics/extended`, data);
  };

  getOperatorStatistics = (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/clients/operator/statistics`, data);
  };

  getOperatorGroupByUserStatistics = (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/clients/operator/statistics/group_by_user`, data);
  };

  getOrdersBonuses = (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/orders/bonuses`, data);
  };

  getUtmAppointmentReport = (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/appointment_journal/utm`, data);
  };

  getUtmOrderReport = (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/orders/utm`, data);
  };

  getEvacuatorRefusalReport = (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/refusals`, data);
  };

  getTAvarcomReport = (data = {}) => {
    return makeRequest('post', `${ REPORT_ORDER_PATH }/t_avarcom`, data);
  };

  getTAvarcomEvacuationReport = (data = {}) => {
    return makeRequest('post', `${ REPORT_ORDER_PATH }/t_avarcom_salary`, data);
  };

  getTBankCheckReport = (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/t_bank/check/date_range`, data);
  };

  getTBankCheckDateReport = (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/t_bank/check/date`, data);
  };

  getPromoCheckDateRangeReport = (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/promo/check/date_range`, data);
  };

  getPromoCheckDateReport = (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/promo/check/date`, data);
  };

  getBonusCheckDateRangeReport = (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/bonus/check/date_range`, data);
  };

  getBonusCheckDateReport = (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/bonus/check/date`, data);
  };

  getTyreStorageReport = (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/tyre_storage/`, data);
  };

  getCheckTyreServiceReport = (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/tyre_storage_quality/`, data);
  };

  getCheckTyreServiceDateReport = (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/tyre_storage/date`, data);
  };

  getCheckTyreServiceOfficeReport = (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/tyre_storage/office`, data);
  };

  getPaidInvoicesReport = (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/paid/invoices`, data);
  };
  
  getClientReportForMarketingReport = (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/clients`, data);
  }

  // Отчёт «Персональные данные»: клиенты ВезёмКолёса с согласиями.
  // GET-параметры (все опциональные): consentTypeRefValueId (справочник 123),
  // dateFrom/dateTo (ISO 8601 с offset), onlyLatest.
  getClientsWithVezemkolesaConsents = (data = {}) => {
    return makeRequest('get', `${ CLIENT_PATH }/vezemkolesa/with_consents?${ objectToUrlParams(data) }`);
  }

  getWheelsTransfersReport = (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/wheels/transfers`, data);
  }

  getAppointmentsTimeIntervalsReport = (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/appointments/time_intervals`, data);
  }

  getWheelsDeliveryReport = (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/orders/wheels/delivery?paged=false&pageSize=100000`, data);
  }

  getTireServiceReport = (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/clients/tire_statistics`, data);
  }

  getLossAdjustmentReport= (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/loss_adjustment`, data);
  }

  getLossAdjustmentUserReport= (data = {}) => {
    return makeRequest('post', `${ REPORT_PATH }/employee_stats`, data);
  }

  // POST /v1/reports/loss_adjustment/email

  // Отчёт по записям для Совкомбанка.
  // Эндпоинт живёт во втором API (API2_URL), поэтому apiBase задаётся явно.
  getSovkombankAppointmentReport = (data = {}) => {
    return makeRequest('post', '/v1/report/appointment', data, { apiBase: process.env.API2_URL });
  };

  // Границы рабочих часов офисов за период — подсветка нерабочих дней на
  // тепловых картах «офис × период». Тот же второй API, что и отчёт по записям.
  getSovkombankWorkingHours = (data: WorkingHoursReportRequest) => {
    return makeRequest('post', '/v1/report/appointment/working/hours', data, { apiBase: process.env.API2_URL });
  };

  // Аналитика заявок ШМ (заказы шиномонтажа с разбивкой по позициям счёта).
  // Эндпоинт живёт во втором API (API2_URL, svc-support) — как и отчёт по
  // записям для Совкомбанка, поэтому apiBase задаётся явно.
  getTireServiceOrdersReport = (data: TireServiceReportRequest) => {
    return makeRequest('post', '/v1/report/tire/service', data, { apiBase: process.env.API2_URL });
  };

  // Аналитика хранения (заказы хранения шин, сервис 69). Тот же второй API
  // (API2_URL, svc-support), что и заявки ШМ.
  getTireStorageOrdersReport = (data: TireStorageReportRequest) => {
    return makeRequest('post', '/v1/report/tire/storage', data, { apiBase: process.env.API2_URL });
  };

  // Аналитика клиентов (клиенты, зарегистрированные за период, с агрегатами
  // по их заказам). Тот же второй API (API2_URL, svc-support).
  getClientStatisticReport = (data: ClientStatisticReportRequest) => {
    return makeRequest('post', '/v1/report/client/statistic', data, { apiBase: process.env.API2_URL });
  };
}

export default new reportController();
